import {
  AppContextActions,
  AppContextActionTypes,
  AppContextState,
} from './types';

/**
 * Reducer for the App Context
 * @param {AppContextState} state
 * @param {AppContextActions} action
 * @returns {AppContextState}
 */
export const appContextReducer = (
  state: AppContextState,
  action: AppContextActions,
): AppContextState => {
  switch (action.type) {
    case AppContextActionTypes.SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };
    case AppContextActionTypes.SET_IS_DARK:
      return {
        ...state,
        isDark: action.payload,
      };
    default:
      return state;
  }
};
